import { CapitalizeNames as capitalize } from 'src/utils/capitalize';
import { IUser } from 'src/interfaces/user';
import { TSelectItem } from '../components/types';

/**
 * Maps the agents to a select item
 *
 * @param {IUser[]} agents
 * @return {*}  {TSelectItem[]}
 */
export const mapAgents = (agents: IUser[]): TSelectItem[] =>
    agents.map((agent) => ({
        value: agent._id,
        label: capitalize(agent.name),
    }));
